import styled from "styled-components";
import breakpoints, { minWidth } from "../UI/breakpoints";
import { COLORS } from "../UI/Constants";

const HeaderItemLink = styled.button`
  border: 0;
  cursor: pointer;
  background: transparent;

  padding: 0 10px;
  display: inline-block;
  position: relative;
  &.header-burger-icon {
    span {
      margin-top: 8px;
      display: inline-block;
    }
    display: inline-block;
    ${minWidth(1100)} {
      display: none;
      overflow: hidden
    }
  }
  p {
    display: inline-block;
    position: relative;
    padding: 8px 0;
    :before {
      content: '';
      position: absolute;
      bottom: 0;
      height: 3px;
      background-color: ${COLORS.PRIMARY};
      width: 100%;
      opacity: 0;
      transform: translateY(10px);
      transition: 250ms;
    }
  }
  :hover {
    cursor: pointer;
    p {
      :before {
        transform: translateY(0);
        opacity: 1
      }
    }
  }

  &.phone-call-icon {
    display: none;
    text-decoration: none !important;
    p {
      padding-left: 5px;
      :before {
        display: none;
      }
    }
    span {
      :before {
        color: ${COLORS.PRIMARY}
      }
    }
    ${breakpoints.md} {
      display: block;
    }
  }
`

export default HeaderItemLink
